// Logout, session expiry and the forced re-login after a deploy all wipe localStorage. Those call sites
// used `localStorage.clear("expireDate")` - clear() takes no argument, so it wiped EVERYTHING, including
// the dashboard the user chose (classic or modern). On the next login the district default won again,
// which is why choosing classic "didn't stay on". Wipe everything except the user's own preferences.
const PRESERVED_KEYS = ["default_dashboard_type", "dashboard_user_choice"];

export function clearSessionStorage(storage = window.localStorage) {
  const kept = {};
  for (const key of PRESERVED_KEYS) {
    const value = storage.getItem(key);
    if (value !== null) kept[key] = value;
  }
  storage.clear();
  for (const [key, value] of Object.entries(kept)) {
    storage.setItem(key, value);
  }
}
